import { PaginationState } from 'app/shared/pagination/pagination.model';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { toast } from 'react-toastify';
import { AddedPersonModel } from 'app/edozvola/cases/added-person/model/added-person.model';
import { deleteAddedPerson, fetchAddedPeople, getAddedPerson, saveAddedPerson } from 'app/edozvola/cases/added-person/service/added-person.service';
import success = toast.success;
import error = toast.error;
import { messages, TABLE_QUERY_KEYS } from 'app/config/constants';

export const fetchAddedPeopleQuery = (pagination: PaginationState, idCase: string) => {
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.ADDED_PEOPLE_TABLE, { idCase: idCase, pagination: { ...pagination } }],
    queryFn: ({ signal }) => fetchAddedPeople(idCase, pagination.page, pagination.size, pagination.column, pagination.direction),
  });
};

export const deleteAddedPersonQuery = () => {
  return useMutation({
    mutationFn: (idAddedPerson: number) => deleteAddedPerson(idAddedPerson),
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.ADDED_PEOPLE_TABLE] });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchAddedPersonQuery = (idAddedPerson: string) => {
  return useQuery({
    queryKey: ['added-person', idAddedPerson],
    queryFn: () => getAddedPerson(idAddedPerson),
    enabled: !!idAddedPerson,
  });
};

export const saveAddedPersonQuery = (idCase: string, onSuccessCallback) => {
  return useMutation({
    mutationFn: (addedPerson: AddedPersonModel) => {
      return saveAddedPerson(idCase, addedPerson);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.ADDED_PEOPLE_TABLE] });
      onSuccessCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
